import PlasmaBackground from '../components/PlasmaBackground';
import AppStoreBadge    from '../components/AppStoreBadge';
import useReducedMotion from '../hooks/useReducedMotion';
import useScrollReveal  from '../hooks/useScrollReveal';

import finishedSvg from '../assets/images/finished.svg';

export default function DownloadCTA() {
  const reducedMotion = useReducedMotion();
  const [ref, visible] = useScrollReveal();

  return (
    <section className="section cta-section" style={{ position: 'relative', overflow: 'hidden' }}>
      <PlasmaBackground />
      <div className="container section-content" ref={ref}>
        <div className={`reveal ${visible ? 'visible' : ''}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img
            src={finishedSvg}
            alt="Solved mascot"
            className={`cta-mascot${reducedMotion ? '' : ' float-anim'}`}
          />
          <h2 className="cta-headline">Start solving.</h2>
            <p className="cta-sub">Download Ripple free on iOS and Android.</p>
          <AppStoreBadge />
        </div>
      </div>
    </section>
  );
}
